// eslint-disable-next-line no-restricted-imports
import { getTolgee as _getTolgee, type TolgeeInstance } from "@tolgee/svelte";
import type { TolgeeEvent } from "@tolgee/web";
import { fromStore } from "svelte/store";
import { fallbackLanguage } from "./fallbackLanguage";

export interface TolgeeData {
	value: TolgeeInstance;
	language: string;
}

export function getTolgee(events?: TolgeeEvent[]): TolgeeData {
	const tolgee = _getTolgee(events);
	const value = fromStore(tolgee);

	let language = $state(value.current.getLanguage() ?? fallbackLanguage);
	value.current.on("language", (event) => {
		language = event.value;
	});

	return {
		get value(): TolgeeInstance {
			return value.current;
		},
		get language(): string {
			return language;
		},
	};
}
